import React, { useEffect, useRef, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images, captions = {}, start = 0, name, onClose }) => {
  const [i, setI] = useState(start);
  const touch = useRef(null);
  const n = images.length;
  const go = (d) => setI((v) => (v + d + n) % n);

  useEffect(() => {
    const key = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };
    window.addEventListener("keydown", key);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", key); document.body.style.overflow = prev; };
  }, [n]); // eslint-disable-line react-hooks/exhaustive-deps

  const cap = captions[images[i]];

  return (
    <div className="fixed inset-0 z-[100] bg-[#120b0c] flex flex-col" data-testid="lightbox"
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { const dx = e.changedTouches[0].clientX - (touch.current ?? 0); if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1); }}>
      <div className="flex items-center justify-between px-5 py-4 text-white/80 text-sm">
        <span data-testid="lightbox-counter">{i + 1} / {n}</span>
        <button onClick={onClose} aria-label="Kapat" data-testid="lightbox-close" className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors"><X className="w-6 h-6" /></button>
      </div>

      <div className="relative flex-1 flex items-center justify-center px-4 min-h-0" onClick={(e) => e.target === e.currentTarget && onClose()}>
        <img key={i} src={images[i]} alt={cap || `${name} fotoğraf ${i + 1}`} className="w-full h-full object-contain animate-fade-in select-none" data-testid="lightbox-image" />
        {n > 1 && (
          <>
            <button onClick={() => go(-1)} aria-label="Önceki" data-testid="lightbox-prev" className="absolute left-3 md:left-6 w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20 transition-colors"><ChevronLeft className="w-6 h-6" /></button>
            <button onClick={() => go(1)} aria-label="Sonraki" data-testid="lightbox-next" className="absolute right-3 md:right-6 w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20 transition-colors"><ChevronRight className="w-6 h-6" /></button>
          </>
        )}
      </div>

      <p className="text-center text-white text-base md:text-lg font-display min-h-[2rem] px-5 pt-3" data-testid="lightbox-caption">{cap || ""}</p>

      {n > 1 && (
        <div className="flex gap-2 overflow-x-auto px-5 py-4 justify-start md:justify-center" data-testid="lightbox-thumbs">
          {images.map((src, k) => (
            <button key={src} onClick={() => setI(k)} data-testid={`lightbox-thumb-${k}`}
              className={`shrink-0 w-16 h-12 md:w-20 md:h-14 rounded-md overflow-hidden transition-[opacity,box-shadow] ${k === i ? "ring-2 ring-[#C6A15B] opacity-100" : "opacity-50 hover:opacity-90"}`}>
              <img src={src} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
